export default "__VITE_PUBLIC_ASSET__5cbaa0ce__"